import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemIcon, ListItemText, SvgIcon } from '@material-ui/core';
import { STANLEY_GROUP_ID, SA_MATCHES_GROUP_ID, STANLEY_ELIGIBLE_GROUP_ID } from 'constants/groups';
import { ClientsIcon2, DigitalClientLeadIcon, StanleyBrandIcon } from 'sharedComponents/Icons';
import useStyles from './GroupList.styles';

export const GroupItem = ({
  groupId,
  name,
  coverColor,
  clientsCount,
  redirectToGroupPage,
  newStanleyMatches,
  newMatchedClients,
}) => {
  const classes = useStyles({ coverColor });
  const isMatchedClientsGroup = groupId === SA_MATCHES_GROUP_ID;
  const isStanleyGroup = groupId === STANLEY_GROUP_ID;
  const isStanleyEligible = groupId === STANLEY_ELIGIBLE_GROUP_ID;

  const newMatches = () => {
    const hasStanleyMatches = isStanleyGroup && newStanleyMatches >= 1;
    const hasDigitalClientLeadMatches = isMatchedClientsGroup && newMatchedClients >= 1;

    if (hasStanleyMatches || hasDigitalClientLeadMatches) {
      return (
        <div>
          <span>{clientsCount} clients</span>
          <span className={classes.secondary}>{newStanleyMatches || newMatchedClients} NEW</span>
        </div>
      );
    }
    return <span>{clientsCount} clients</span>;
  };

  const renderGroupIcon = () => {
    if (isMatchedClientsGroup) {
      return <SvgIcon component={DigitalClientLeadIcon} height="20" viewBox="0 -1 20 20" />;
    }
    if (isStanleyEligible) {
      return (
        <SvgIcon
          classes={{ root: classes.stanleyFillColor }}
          component={StanleyBrandIcon}
          width="20"
          height="20"
          viewBox="0 0 250 250"
        />
      );
    }
    return <SvgIcon component={ClientsIcon2} viewBox="0 0 20 20" />;
  };

  return (
    <ListItem
      data-testid="list-item"
      className={classes.item}
      onClick={() => redirectToGroupPage(groupId, clientsCount)}
    >
      <ListItemIcon classes={{ root: classes.itemIcon }}>{renderGroupIcon()}</ListItemIcon>

      <ListItemText primary={name} secondary={newMatches()} />
    </ListItem>
  );
};

const GroupList = ({ groups, redirectToGroupPage }) => {
  return (
    <List data-testid="list">
      {groups.map((group, index) => (
        <GroupItem
          key={group.groupId || `group_${index}`}
          redirectToGroupPage={redirectToGroupPage}
          newStanleyMatches={group.newStanleyMatches}
          newMatchedClients={group.newMatchedClients}
          {...group}
        />
      ))}
    </List>
  );
};

const ClientGroupPropType = PropTypes.shape({
  groupId: PropTypes.string,
  description: PropTypes.string,
  coverColor: PropTypes.string,
  name: PropTypes.string,
  clientsCount: PropTypes.number,
  averageAnnualAmount: PropTypes.number,
  yearPurchasesAmount: PropTypes.number,
  creationTime: PropTypes.string,
  defaultGroup: PropTypes.bool,
});

GroupList.propTypes = {
  groups: PropTypes.arrayOf(ClientGroupPropType),
  redirectToGroupPage: PropTypes.func,
};

GroupList.defaultProps = {
  groups: [],
  redirectToGroupPage: () => null,
};

export default GroupList;
